import React from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import mapBg from "../assets/map.png";
import Navbar from "../components/Navbar";

function AppSelector() {
  const navigate = useNavigate();

  const handleAppClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${mapBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          p: 4,
          position: "relative"
        }}
      >
        {/* Overlay to make content readable over map */}
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          zIndex: 1
        }} />

        <Box sx={{ position: "relative", zIndex: 2, width: "100%", maxWidth: 1000 }}>
          <Typography variant="h4" sx={{ mb: 4, fontWeight: 600, color: "#1a1a1a" }}>
            Welcome, User | <span style={{ fontWeight: 400 }}>Your Applications</span>
          </Typography>

          <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 3 }}>

            {/* Fiber Design Card */}
            <Card
              sx={{
                width: 300,
                borderRadius: 3,
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                borderTop: "6px solid #1a237e"
              }}
            >
              <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", p: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2, mb: 1, color: "#1a1a1a" }}>
                  FIBER DESIGN
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4, flex: 1 }}>
                  Process and analyze geographic imagery to generate detailed fiber designs and layouts.
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleAppClick("/fibre")}
                  sx={{
                    bgcolor: "#1a237e",
                    color: "white",
                    borderRadius: 2,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    "&:hover": { bgcolor: "#0d47a1" }
                  }}
                >
                  View
                </Button>
              </CardContent>
            </Card>

            {/* TempDrop Card */}
            <Card
              sx={{
                width: 300,
                borderRadius: 3,
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                borderTop: "6px solid #42a5f5"
              }}
            >
              <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", p: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2, mb: 1, color: "#1a1a1a" }}>
                  TEMPDROP
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4, flex: 1 }}>
                  Review and validate temporary drop statuses using aerial satellite imagery and markers.
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleAppClick("/projectdetail")}
                  sx={{
                    bgcolor: "#42a5f5",
                    color: "white",
                    borderRadius: 2,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    "&:hover": { bgcolor: "#1e88e5" }
                  }}
                >
                  View
                </Button>
              </CardContent>
            </Card>

            {/* IntelliDrop Card */}
            <Card
              sx={{
                width: 300,
                borderRadius: 3,
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                borderTop: "6px solid #4caf50"
              }}
            >
              <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", p: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2, mb: 1, color: "#1a1a1a" }}>
                  INTELLIDROP
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4, flex: 1 }}>
                  Track, process, and manage tickets for fiber terminal drops across multiple locations.
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleAppClick("/transactions")}
                  sx={{
                    bgcolor: "#4caf50",
                    color: "white",
                    borderRadius: 2,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    "&:hover": { bgcolor: "#388e3c" }
                  }}
                >
                  View
                </Button>
              </CardContent>
            </Card>

          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AppSelector;
